module.exports = __webpack_public_path__ + "static/media/wifi-icon.1904a46f.png";